let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1GADu")).then(() => parcelRequire('5pYmc'));